module.exports = new __parcel__URL__("mango.6b9252cb.svg").toString();